"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClearIndicator = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _core = require("@emotion/core");
var _lodestarIcons = require("@smartsheet/lodestar-icons");
var _reactSelect = require("react-select");
var _colors = require("../../../constants/colors");
var _spacing = require("../../../constants/spacing");
/** @jsxRuntime classic */
/** @jsx jsx */

const ClearIndicator = props => (0, _core.jsx)(_reactSelect.components.ClearIndicator, (0, _extends2.default)({}, props, {
  css: (0, _core.css)`
            ${props.selectProps.isDisabled ? `
                    color: ${_colors.neutral};
                    &:hover {
                        color: ${_colors.neutral};
                    }
                ` : `
                    color: ${_colors.neutralDark20};
                    &:hover {
                        color: ${_colors.neutralDark40};
                    }
                `}
            padding: 0 ${_spacing.sizes.xSmall}px 0 0;
        `
}), (0, _core.jsx)(_lodestarIcons.CloseIcon, {
  size: "xSmall",
  "aria-label": "clear"
}));
exports.ClearIndicator = ClearIndicator;
//# sourceMappingURL=ClearIndicator.js.map